export default __webpack_public_path__ + "147dd3822a7f6cf0bbf059bf8474194e.png";